import React, { useContext } from "react";
import PropTypes from "prop-types";
import { GlobalContext } from "GlobalContext";
import { getDay, getMonth, getYear } from "utils";
import Reveal from "ui/Reveal";

import {
  CardLink,
  Media,
  Details,
  DateBadge,
  Day,
  MonthYear,
  Content,
  Title,
  ReadMore,
} from "./styles/DatedCardStyles";

// The news and publication cards: image, date badge, title. A real link (so it
// opens in a new tab and is reachable by keyboard); a plain click stays in the
// app. With revealDelay set, the card fades in when scrolled into view.
const DatedCard = ({ className, path, image, date, title, revealDelay }) => {
  const { navigateTo, currentLang } = useContext(GlobalContext);
  const isEn = currentLang === "en";

  const onClick = (e) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    navigateTo(path);
  };

  const card = (
    <CardLink
      className={className}
      href={(isEn ? "/en" : "") + path}
      onClick={onClick}
    >
      <Media>
        {image && image.sourceUrl && (
          <img
            src={image.sourceUrl}
            alt={image.altText || ""}
            loading="lazy"
            decoding="async"
          />
        )}
      </Media>
      <Details>
        <DateBadge>
          <Day>{getDay(date)}</Day>
          <MonthYear>
            {getMonth(date, isEn ? "en" : "fr")} {getYear(date)}
          </MonthYear>
        </DateBadge>
        <Content>
          <Title dangerouslySetInnerHTML={{ __html: title }} />
          <ReadMore>
            {isEn ? "Read more" : "Lire la suite"}
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path d="M5 12h14M13 6l6 6-6 6" />
            </svg>
          </ReadMore>
        </Content>
      </Details>
    </CardLink>
  );

  return revealDelay === undefined ? (
    card
  ) : (
    <Reveal stretch delay={revealDelay}>
      {card}
    </Reveal>
  );
};

DatedCard.propTypes = {
  className: PropTypes.string,
  path: PropTypes.string.isRequired,
  image: PropTypes.object,
  date: PropTypes.string,
  title: PropTypes.string,
  revealDelay: PropTypes.number,
};

export default DatedCard;
